<main class="min-h-screen bg-gray-50 pb-20">
  <!-- 헤더 -->
  <div class="bg-linear-to-b from-primary-50 to-gray-50 px-4 py-8 lg:pt-36 lg:pb-10">
    <div class="container mx-auto flex flex-col items-center text-center gap-3">
      <span
        class="inline-flex items-center justify-center gap-1.5 text-xs font-semibold text-primary-600 bg-primary-100 px-3 py-1 rounded-full w-fit">
        <app-icon name="material-symbols:location-on" class="size-3.5!" />
        김대중컨벤션센터
      </span>
      <h1 class="text-2xl font-extrabold text-zinc-800 lg:text-3xl sb-aggro">오시는 길</h1>
      <p class="text-sm text-zinc-500">행사장 위치 및 교통 정보를 안내합니다.</p>
    </div>
  </div>

  <div class="container mx-auto px-4 py-6 flex flex-col gap-6">
    <!-- 장소 정보 카드 -->
    <div class="bg-white rounded-2xl p-5 border border-zinc-100 shadow-sm flex flex-col gap-4">
      <div class="flex items-start gap-3">
        <div class="w-10 h-10 bg-primary-50 rounded-xl flex items-center justify-center shrink-0">
          <app-icon name="material-symbols:location-on" class="size-5! text-primary-500" />
        </div>
        <div class="flex flex-col gap-1">
          <h2 class="text-base font-bold text-zinc-800">{{ venue.name }}</h2>
          <p class="text-sm text-zinc-500">{{ venue.address }}</p>
          <p class="text-sm text-zinc-400">TEL. {{ venue.phone }}</p>
        </div>
      </div>

      <!-- 카카오맵 -->
      <div id="kakao-map-directions" class="w-full rounded-xl overflow-hidden" style="height: 280px"></div>

      <!-- 버튼 -->
      <div class="flex gap-3">
        <button
          (click)="openKakaoMapDirections()"
          class="cursor-pointer flex-1 flex items-center justify-center gap-2 p-3 text-zinc-900 rounded-xl border border-zinc-200 hover:bg-zinc-50 transition-colors text-sm font-medium">
          <app-icon name="streamline:location-pin-3" class="size-4! text-primary-500" />
          길찾기
        </button>
        <button
          (click)="openKakaoMapDetail()"
          class="cursor-pointer flex-1 flex items-center justify-center gap-2 p-3 text-zinc-800 rounded-xl bg-zinc-100 hover:bg-zinc-200 transition-colors text-sm font-medium">
          <app-icon
            name="streamline:interface-arrows-bend-up-right-1-arrow-bend-curve-change-direction-right-to-up"
            class="size-4! text-zinc-500" />
          상세안내
        </button>
      </div>
    </div>

    <!-- 지하철 -->
    <div class="bg-white rounded-2xl p-5 border border-zinc-100 shadow-sm flex flex-col gap-3">
      <div class="flex items-center gap-2">
        <app-icon name="material-symbols:subway" class="size-5! text-primary-500" />
        <h3 class="font-bold text-zinc-800">지하철</h3>
      </div>
      <div class="ml-7 flex flex-col gap-2 text-sm text-zinc-600">
        <div class="flex items-start gap-2">
          <span
            class="inline-flex items-center justify-center rounded-full bg-[#00a651] text-white text-xs font-bold w-5 h-5 shrink-0 mt-0.5"
            >1</span
          >
          <p>
            <span class="font-medium text-zinc-800">광주도시철도 1호선</span> 김대중컨벤션센터역 하차<br /><span
              class="text-zinc-400"
              >2번 출구 이용 (도보 1분)</span
            >
          </p>
        </div>
      </div>
    </div>

    <!-- 버스 -->
    <div class="bg-white rounded-2xl p-5 border border-zinc-100 shadow-sm flex flex-col gap-3">
      <div class="flex items-center gap-2">
        <app-icon name="material-symbols:directions-bus" class="size-5! text-primary-500" />
        <h3 class="font-bold text-zinc-800">버스</h3>
      </div>
      <div class="ml-7 flex flex-col gap-3 text-sm text-zinc-600">
        <div>
          <span class="inline-block bg-blue-100 text-blue-700 text-xs font-medium px-2 py-0.5 rounded mb-1">간선</span>
          <p>518 · 상무63 · 상무64</p>
        </div>
        <div>
          <span class="inline-block bg-green-100 text-green-700 text-xs font-medium px-2 py-0.5 rounded mb-1"
            >순환</span
          >
          <p>순환01A · 순환01B · 지선402</p>
        </div>
        <div>
          <span class="inline-block bg-yellow-100 text-yellow-700 text-xs font-medium px-2 py-0.5 rounded mb-1"
            >지선</span
          >
          <p>월곡38 · 운림50 · 지원25</p>
        </div>
      </div>
    </div>

    <!-- 주차 -->
    <div class="bg-white rounded-2xl p-5 border border-zinc-100 shadow-sm flex flex-col gap-3">
      <div class="flex items-center gap-2">
        <app-icon name="tabler:parking-circle" class="size-5! text-primary-500" />
        <h3 class="font-bold text-zinc-800">주차 안내</h3>
      </div>
      <div class="ml-7 flex flex-col gap-2 text-sm text-zinc-600">
        <div class="flex items-start gap-2">
          <app-icon name="material-symbols:check-circle-outline" class="size-4! text-primary-400 shrink-0 mt-0.5" />
          <p>김대중컨벤션센터 지하주차장 이용 가능</p>
        </div>
        <div class="flex items-start gap-2">
          <app-icon name="material-symbols:check-circle-outline" class="size-4! text-primary-400 shrink-0 mt-0.5" />
          <p>주차 요금: 최초 30분 무료, 이후 10분당 300원</p>
        </div>
        <div class="flex items-start gap-2">
          <app-icon name="material-symbols:info-outline" class="size-4! text-amber-400 shrink-0 mt-0.5" />
          <p class="text-zinc-400">행사 기간 중 주차 혼잡이 예상되오니 대중교통 이용을 권장합니다.</p>
        </div>
      </div>
    </div>
  </div>
</main>
